import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'datesDuration',
})
export class DatesDurationPipe implements PipeTransform {

    transform(fromDate: Date | string, toDate?: Date | string, includes?: boolean): string {
        const to = toDate ? new Date(toDate) : new Date();
        const from = fromDate ? new Date(fromDate) : new Date();
        const diffTime = Math.abs(to.getTime() - from.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1 - (includes ? 0 : 1);
        return diffDays === 1 ? `${diffDays} day` : `${diffDays} days`;
    }

}
